import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import bgDefaultVideo from './assets/video/bgVideo.webm';
import posterDefault from './assets/images/poster.png';

import advtImg from './assets/images/advt.png';

import { useMemo } from 'react';

function App() {
  const {
    currentState,
    isVisible,
    currentMessage,
    messages,
    clicker,
    currentType,
  } = useBroadcast();
  const {
    bg,
    title,
    bgVideo,
    bgPoster,
    msgFontSize,
    titleFontSize,
    marginMsg,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      label: title,
    }),
    [title],
  );

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              }) center/cover no-repeat`
            : 'none',
      }}
    >
      <Advt advtInfo={advt_info} titleFontSize={titleFontSize} />

      <div className="message-wrapper">
        <CSSTransition
          in={Boolean(currentState) && Boolean(messages?.length) && isVisible}
          timeout={500}
          classNames="fade-scale"
          unmountOnExit
        >
          <SwitchTransition>
            <CSSTransition
              key={currentType}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit
            >
              <div
                className="messageList"
                style={{
                  marginTop: `${
                    ['S5', 'S6', 'S7', 'S8'].includes(currentState)
                      ? marginMsg
                      : 0
                  }rem`,
                }}
              >
                {messages &&
                  messages.map((el) => (
                    <Message
                      isCurrent={
                        el.id === currentMessage?.id &&
                        currentState &&
                        (!['S1', 'S5'].includes(currentState) || clicker)
                      }
                      className="titre-message"
                      message={el.message || {}}
                      key={el.id}
                      currentState={currentState}
                      msgFontSize={msgFontSize}
                      clicker={clicker}
                    />
                  ))}
              </div>
            </CSSTransition>
          </SwitchTransition>
        </CSSTransition>
      </div>

      <div className="developText">
        <span>разработано</span> iactive.pro
      </div>

      <div id="img-loader"></div>
      {bgVideo && (
        <video
          playsInline
          autoPlay="autoplay"
          muted="muted"
          loop
          poster={bgVideo === '1' ? posterDefault : bgPoster}
          id="bgVideo"
        >
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/webm"
          ></source>
        </video>
      )}

      {!advt_info.label && (
        <div className="advtImg">
          <img src={advtImg} alt="" />
        </div>
      )}
    </div>
  );
}
export default App;
